import { useAuth } from './auth';
import { resolveAssetUrl } from './ultra-meet-config';

const PARTNER_LOGO_SRC = '/images/sk.png';

const PARTNER_LOGO_EMAILS = new Set<string>([
    `bukenov.talgat@gmail.com`,
    `bukenov.t@telecom.kz`,
    `ibrayev.yer@telecom.kz`,
    `adilkhan.mk@telecom.kz`,
    `abrayev.zh@telecom.kz`,
    `tabultayev.a@telecom.kz`,
    `gabdullin.b@telecom.kz`,
    `ibrayev.mk@telecom.kz`,
    `satybaldy.n@telecom.kz`,
    `baktybayev.yer@telecom.kz`,
    `turgynov.m@telecom.kz`,
    `malikova.p@telecom.kz`,
    `mukhtar.d@telecom.kz`,
    `idrissova.k@telecom.kz`,
    `aryn.ye@telecom.kz`,
    `mukashev.dn@telecom.kz`,
    `netalina.a@telecom.kz`,
    `magperov.k@telecom.kz`,
    `rakhimzhanova.mr@telecom.kz`,
    `buzaubayev.p@telecom.kz`,
    `ospanov.aln@telecom.kz`,
    `adminsk-01@telecom.kz`,
    `adminsk-02@telecom.kz`,
    `presentationsk@telecom.kz`,
]);

export function usePartnerLogoUrl(): string | null {
    const { user, isAuthenticated } = useAuth();

    if (!isAuthenticated || !user?.email) return null;
    if (!PARTNER_LOGO_EMAILS.has(user.email.trim().toLowerCase())) return null;

    return resolveAssetUrl(PARTNER_LOGO_SRC);
}
